export const getAcpAppName = (): "ac" | "cp" => {
	const value =
		import.meta.env.VITE_ACP_APP_NAME ||
		(window as Window & { __ACP_APP_NAME__?: string }).__ACP_APP_NAME__;

	if (!value) {
		console.warn(
			'[acp] getAcpAppName: VITE_ACP_APP_NAME and window.__ACP_APP_NAME__ are both unset. Falling back to "ac".',
		);
		return "ac";
	}

	return value as "ac" | "cp";
};
